const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/rsa/api-factory');
const serviceFactory = require('../resources/rsa/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/rsaauthentication/${apiConfig.apiversion}/`,
  });

  const service = serviceFactory({ api });

  const p = '[{keys:metaData}].';

  function parseToken(rsaToken) {
    const token = rsaToken.replace('t', '');
    return token;
  }

  return app => app
     .match(`${p}rsa.validateToken[{keys:rsaToken}]`, requests => Promise.all(
      requests.map(({ req, res }) => 
        service.validateToken(req.params.rsaToken,req.params.metaData)
          .then(response => res.value(response.rsaTokenSuccess))
          .catch(res.error)))); 
}

module.exports = addRoutes;
